import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Tag from "../components/Tag";
import {
  getScrollAnimationVariants,
  defaultScrollViewportSettings,
  staggerItemVariants,
} from "../hooks/useScrollAnimation";

import "./Clients.css";

// Import client illustrations
import clientCreator from "../assets/illustrations/client-creator.jpeg";
import clientEcommerce from "../assets/illustrations/client-ecommerce.jpeg";
import clientStartup from "../assets/illustrations/client-startup.jpeg";
import clientArt from "../assets/illustrations/client-art.jpeg";

// Map illustrations to client cards
const CLIENT_IMAGES = [
  clientCreator,
  clientEcommerce,
  clientStartup,
  clientArt,
];

export default function Clients() {
  const { t } = useTranslation();
  const containerVariants = getScrollAnimationVariants("staggerChildren");

  const items = [
    {
      tag: t("clients.client1Tag"),
      title: t("clients.client1Title"),
      description: t("clients.client1Desc"),
      footer: t("clients.client1Footer"),
    },
    {
      tag: t("clients.client2Tag"),
      title: t("clients.client2Title"),
      description: t("clients.client2Desc"),
      footer: t("clients.client2Footer"),
    },
    {
      tag: t("clients.client3Tag"),
      title: t("clients.client3Title"),
      description: t("clients.client3Desc"),
      footer: t("clients.client3Footer"),
    },
    {
      tag: t("clients.client4Tag"),
      title: t("clients.client4Title"),
      description: t("clients.client4Desc"),
      footer: t("clients.client4Footer"),
    },
  ];

  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={defaultScrollViewportSettings}
      variants={containerVariants}
    >
      <div className="section-title">
        <h2>{t("clients.title")}</h2>
        <p>{t("clients.subtitle")}</p>
      </div>

      <div className="clients-grid">
        {items.map(({ tag, title, description, footer }, index) => (
          <motion.div
            key={index}
            className="client-card"
            variants={staggerItemVariants}
          >
            <img
              src={CLIENT_IMAGES[index]}
              alt={`${title} illustration`}
              className="img-container"
            />
            <Tag
              style={{ backgroundColor: `var(--tag-color-${(index % 3) + 1})` }}
            >
              {tag}
            </Tag>
            <h4>{title}</h4>
            <p>{description}</p>
            <div className="client-card-footer">
              <h5>{t("clients.why")}</h5>
              <p className="text-s">{footer}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
}
